import React, { FormEventHandler, useState } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { VARIANT_OF_REFUND_SURCHARGE } from '~/consts/refund';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';
import MarkCancelled from '../Common/MarkCancelled';

import SelectRefundVariantWithSurcharge from './SelectRefundVariantWithSurcharge';

interface Props {
  reason: CollectionReason;
  onSubmit: FormEventHandler<HTMLFormElement>;
  decrementStep: () => void;
  defaultComment: string;
  currencyCode: string;
  hasSurcharge?: boolean;
  surchargeAmount?: number;
  defaultCaseId: string;
}

export default function FailedRefundFromPaymentGateways({
  reason,
  onSubmit,
  decrementStep,
  defaultComment,
  currencyCode,
  hasSurcharge = false,
  surchargeAmount,
  defaultCaseId,
}: Props) {
  const [variantOfRefund, setVariantOfRefund] = useState<string>();
  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="failed-refund-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
          <SelectRefundVariantWithSurcharge
            hasSurcharge={hasSurcharge}
            currencyCode={currencyCode}
            setVariantOfRefund={setVariantOfRefund}
            variantOfRefund={variantOfRefund}
            surchargeAmount={surchargeAmount}
          />
          {variantOfRefund !== VARIANT_OF_REFUND_SURCHARGE && <MarkCancelled />}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" form="failed-refund-form" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
